import { Box, Stack, Typography } from '@mui/material';

import { themeColors, brandColors } from 'colors';
import { Campaign } from 'domains/campaigns/types';
import { formatDateTime } from 'domains/core/components/DateRangeText/DateRangeText';

type SendingTestStatusProps = {
    campaign: Campaign;
};

const SendingTestStatus = ({ campaign }: SendingTestStatusProps) => {
    const testEndsOn = campaign.abTestConfig?.testEndsOn;

    return (
        <Box
            sx={{
                backgroundColor: brandColors.garlic,
                borderRadius: '8px',
                padding: '16px',
                paddingLeft: '24px',
            }}
        >
            <Stack spacing={0.5}>
                <Stack direction="row" alignItems="baseline" spacing={1.4}>
                    <Box
                        sx={{
                            width: '8px',
                            height: '8px',
                            borderRadius: '50%',
                            backgroundColor: themeColors.other.ratingActive,
                        }}
                    />
                    <Typography>sending test</Typography>
                </Stack>
                {testEndsOn && (
                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                        Ends on {formatDateTime(testEndsOn)}
                    </Typography>
                )}
            </Stack>
        </Box>
    );
};

export default SendingTestStatus;
